import { customFetch } from "./custom-fetch";
import { useMutation } from "@tanstack/react-query";

export interface SendEmailBody {
  subject: string;
  message: string;
  attachmentBase64?: string;
  attachmentFilename?: string;
  ccSelf?: boolean;
  attachServiceAgreement?: boolean;
}

export interface SendEmailResult {
  success: boolean;
  to: string;
  lastReminderSentAt?: string;
}

export async function sendEstimateEmail(id: number, body: SendEmailBody): Promise<SendEmailResult> {
  return customFetch<SendEmailResult>(`/api/estimates/${id}/send-email`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function useSendEstimateEmail() {
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: SendEmailBody }) => sendEstimateEmail(id, body),
  });
}

export async function sendInvoiceEmail(id: number, body: SendEmailBody): Promise<SendEmailResult> {
  return customFetch<SendEmailResult>(`/api/invoices/${id}/send-email`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function useSendInvoiceEmail() {
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: SendEmailBody }) => sendInvoiceEmail(id, body),
  });
}

export async function sendInvoiceReminder(id: number): Promise<SendEmailResult> {
  return customFetch<SendEmailResult>(`/api/invoices/${id}/send-reminder`, {
    method: "POST",
  });
}

export function useSendInvoiceReminder() {
  return useMutation({
    mutationFn: ({ id }: { id: number }) => sendInvoiceReminder(id),
  });
}

export async function sendInvoiceReceipt(id: number, ccSelf?: boolean): Promise<SendEmailResult> {
  return customFetch<SendEmailResult>(`/api/invoices/${id}/send-receipt`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(ccSelf ? { ccSelf } : {}),
  });
}

export function useSendInvoiceReceipt() {
  return useMutation({
    mutationFn: ({ id, ccSelf }: { id: number; ccSelf?: boolean }) => sendInvoiceReceipt(id, ccSelf),
  });
}
